module.exports = __webpack_public_path__ + "img/nryu_staking.2f95fd86.webp";